import { PasswordActionTypes } from './actionTypes';
import type {
  ChangePasswordByRecoveryTokenFailed,
  ChangePasswordByRecoveryTokenRequest,
  ChangePasswordByRecoveryTokenRequestPayload,
  ChangePasswordByRecoveryTokenSucceeded,
  ForgetPasswordFailed,
  ForgetPasswordRequest,
  ForgetPasswordSucceeded,
  LoginResetState,
  ValidateToken,
  ValidateTokenFailed,
  ValidateTokenRequest,
  ValidateTokenSucceeded,
} from './actions';
import type { PasswordState } from './reducer';

// Password Recovery

export const changePasswordByRecoveryTokenRequest = (payload: ChangePasswordByRecoveryTokenRequestPayload): ChangePasswordByRecoveryTokenRequest => ({
  type: PasswordActionTypes.CHANGE_PASSWORD_BY_RECOVERY_TOKEN_REQUEST,
  payload,
});

export const changePasswordByRecoveryTokenSucceeded = (): ChangePasswordByRecoveryTokenSucceeded => ({
  type: PasswordActionTypes.CHANGE_PASSWORD_BY_RECOVERY_TOKEN_SUCCEEDED,
});

export const changePasswordByRecoveryTokenFailed = (): ChangePasswordByRecoveryTokenFailed => ({
  type: PasswordActionTypes.CHANGE_PASSWORD_BY_RECOVERY_TOKEN_FAILED,
});

// Foget password (token request)
export const forgetPasswordRequest = (email: string): ForgetPasswordRequest => ({
  type: PasswordActionTypes.FORGET_PASSWORD_REQUEST,
  payload: {
    email,
  },
});

export const forgetPasswordSucceeded = (): ForgetPasswordSucceeded => ({
  type: PasswordActionTypes.FORGET_PASSWORD_SUCCEEDED,
});

export const forgetPasswordFailed = (): ForgetPasswordFailed => ({
  type: PasswordActionTypes.FORGET_PASSWORD_FAILED,
});

// Token validation
export const validateToken = (token: string): ValidateToken => ({
  type: PasswordActionTypes.VALIDATE_TOKEN,
  payload: {
    token,
  },
});

export const validateTokenRequest = (token: string): ValidateTokenRequest => ({
  type: PasswordActionTypes.VALIDATE_TOKEN_REQUEST,
  payload: {
    token,
  },
});

export const validateTokenSucceeded = (): ValidateTokenSucceeded => ({
  type: PasswordActionTypes.VALIDATE_TOKEN_SUCCEEDED,
});

export const validateTokenFailed = (): ValidateTokenFailed => ({
  type: PasswordActionTypes.VALIDATE_TOKEN_FAILED,
});

export const loginResetState = (state: Partial<PasswordState>): LoginResetState => ({
  type: PasswordActionTypes.LOGIN_RESET_STATE,
  payload: state,
});
